import { ReactNode } from 'react'

import z from 'zod'
import { ZodParsedType } from 'zod/v3'

import { HttpStatusCode } from '@/common/util/status'

export const statusCodeErrorMessage = (error: HttpStatusCode | number | undefined): string | ReactNode => {
  switch (Number(error)) {
    case HttpStatusCode.UNAUTHORIZED:
      return '認証されていないリクエストです'
    case HttpStatusCode.VALIDATION_FAILED:
      return '入力項目をご確認ください'
    case HttpStatusCode.NOT_FOUND:
      return (
        <>
          お探しのページが見つかりません
          <br />
          URLに間違いがないかご確認ください。
        </>
      )
    case HttpStatusCode.INTERNAL_SERVER_ERROR:
      return '何か意図しないエラーが起きたようです。お手数おかけしますが、時間をおいてアクセスしてください。'
    case HttpStatusCode.ALREADY_VERIFIED:
      return '既に認証済みです'
    case HttpStatusCode.EXPIRED:
      return '有効期限切れの申請情報です。再度申請するようお願いいたします'
    default:
      return '不正なリクエストです。入力内容が正しい場合、管理者へお問い合わせください。'
  }
}

/**
 * zodエラーメッセージ（日本語）
 */
z.config({
  customError: (issue) => {
    switch (issue.code) {
      case z.ZodIssueCode.invalid_type:
        if (issue.received === ZodParsedType.undefined || issue.received === ZodParsedType.null) {
          return { message: '必須項目です。値を入力してください。' }
        }
        if (issue.expected == 'integer' && issue.received == 'float') {
          return { message: '整数で入力してください。' }
        }
        return { message: '値に誤りがあります' }

      case z.ZodIssueCode.too_big:
        if (issue.type == 'number') {
          return { message: `${issue.maximum}以下の数字で入力してください。` }
        }
        return { message: `上限文字数を超えています。${issue.maximum}文字以内で入力してください` }

      case z.ZodIssueCode.too_small:
        if (issue.type == 'number') {
          return { message: `${issue.minimum}以上の数字で入力してください。` }
        }
        if (issue.type === 'array') {
          return { message: `${issue.minimum}つ以上チェックしてください` }
        }

        if (issue.minimum == 1) {
          return { message: '必須項目です。値を入力してください。' }
        }
        return {
          message: `下限文字数を満たしていません。${issue.minimum}文字以上で入力してください`
        }
      case z.ZodIssueCode.invalid_format:
        if (issue.format == 'url') {
          return { message: 'URLの形式（https://で始まる形）で入力してください。' }
        } else if (issue.format == 'email') {
          return {
            message: '「@」マーク「.」ドットを利用し、メールアドレスの形式で入力してください。'
          }
        }
        return { message: '入力形式が正しくありません。' }
      case 'invalid_value':
        return { message: '必須項目です。値を入力してください。' }
    }
  }
})
